module.exports = __webpack_public_path__ + "static/media/mail.9a87409a.png";